module.exports = __webpack_public_path__ + "static/media/tall-bg-sc.5682bc90.jpg";